export default "__VITE_ASSET__486cd243__"